export const GET_TOKEN = 'GET_TOKEN'
export const UPDATE_TOKEN = 'UPDATE_TOKEN'
export const DELETE_TOKEN = 'DELETE_TOKEN'
export const UPDATE_RECAPTCHA = 'UPDATE_RECAPTCHA'
export const UPDATE_MAIL = 'UPDATE_MAIL'
export const UPDATE_PHONE = 'UPDATE_PHONE'
export const UPDATE_ALERT_SIGNIN = 'UPDATE_ALERT_SIGNIN'